<template>
  <div class="staff">
    <panel-head title="员工管理" subtitle="STAFF MANAGEMENT" :export-url="exportUrl"></panel-head>
    <div class="panel-content">
      <h3 class="panel-content__title">
        员工管理
        <el-button class="has-icon fr" @click="handleAddStaff">
          <i>+&nbsp;</i>新增员工
        </el-button>
      </h3>
      <div class="panel-content__select-list">
        <span>员工角色：</span>
        <ny-select class="mr20 is-small" :data="roles" v-model="role"></ny-select>
        <span>员工名称：</span>
        <el-input class="mr5" v-model="staffName"></el-input>
        <el-button style="margin-top: -4px;" @click="handleSearch">查询</el-button>
      </div>
      <div class="panel-content__table-wrap">
        <ny-table
          class="panel-content__table"
          :page="page"
          @current-change="handlePageChange"
          @size-change="handlePageChange"
        >
          <template slot="operate">
            <el-table-column label="操作" width="180" align="center">
              <template slot-scope="scope">
                <el-button size="small" class="is-edit" @click="handleOperateStaff('edit', scope.row)">编辑</el-button>
                <el-button size="small" class="is-view" @click="handleOperateStaff('view', scope.row)">查看</el-button>
                <ny-popover
                  v-model="scope.row.visible"
                  class="panel-content__table-icon"
                  tip-text="确定要删除该员工吗？"
                  :confirm="() => handleOperateStaff('remove', scope.row)"
                >
                  <el-button class="is-remove" size="small" slot="reference">删除</el-button>
                </ny-popover>
              </template>
            </el-table-column>
          </template>
        </ny-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { PanelHead, NySelect, NyTable, NyPopover } from '@/global/components';
import { get, remove } from '@/agent/http';
import { tip } from '@/global/util/util'

export default {
  name: 'staff',

  components: {
    PanelHead,
    NySelect,
    NyTable,
    NyPopover
  },

  data () {
    return {
      role: '',
      staffName: '',
      data: [],
      plat: 'agency'
    }
  },

  computed: {
    ...mapGetters({
      roles: 'staff/roles',
      page: 'staff/page',
      userid: 'login/userid'
    }),
    exportUrl () {
      return ''
    }
  },

  mounted () {
    this.getRoleTypes()
    this.getStaffList()
  },

  methods: {
    ...mapActions([
      'staff/getStaffList',
      'staff/getRoleTypes',
      'staff/removeStaff'
    ]),
    handleAddStaff () {
      this.$router.push({ path: '/staff/add' })
    },
    handlePageChange ({ currentPage, pageSize }) {
      this.getStaffList()
    },
    async handleOperateStaff (type, row) {
      if (type === 'remove') {
        const data = await this['staff/removeStaff']({ request: remove, id: row.id })
        if (data.code === 1) {
          this.page.data = this.page.data.filter(v => v.id !== row.id)
          row.visible = false
          return tip('删除员工成功', { type: 'success' })
        } else {
          return tip('删除员工失败')
        }
      } else {
        this.$router.push({ path: `/staff/${type}/${row.id}` })
      }
    },
    getRoleTypes () {
      this['staff/getRoleTypes']({
        request: get
      })
    },
    handleSearch () {
      this.page.currentPage = 1
      this.getStaffList()
    },
    getStaffList () {
      this['staff/getStaffList']({
        request: get,
        params: {
          plat: this.plat,
          role_type: this.role,
          user_name: this.staffName,
          parent_id: 1 || this.userid,
          page: this.page.currentPage,
          perpage: this.page.pageSize
        }
      })
    },
    removeStaff (id) {
      const res = this['staff/removeStaff']({ request: remove, id })
      if (res.code === 1) {
        tip('删除成功')
      } else {
        tip('删除失败')
      }
    }
  }
}
</script>

<style lang="scss">
@include b(staff) {
  //body
}
</style>
